export default {
    lessonStatuses: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/lessonStatus/state.js